module.exports = __webpack_public_path__ + "img/thumbnail-sowhatbuy-items.0dd06ac6.webp";